import { FormType } from '../../interfaces/form.interface';

export type ReactiveFormSubmitDecisionAction =
    'skip' |
    'showValidationErrors' |
    'showDeletionWarning' |
    'missingRecordId' |
    'submit';

export interface ReactiveFormSubmitDecisionOptions {
    readonly formType: FormType;
    readonly hasForm: boolean;
    readonly hasModel: boolean;
    readonly hasInvalidSubmittableControls: boolean;
    readonly recordHasAssociatedData: boolean;
    readonly hasWarning: boolean;
    readonly requiresExistingRecordId: boolean;
    readonly hasExistingRecordId: boolean;
}

export interface ReactiveFormSubmitDecisionResult {
    readonly action: ReactiveFormSubmitDecisionAction;
    readonly canSubmit: boolean;
}

/** Resolves pre-submit decisions while keeping request execution outside this utility. */
export class ReactiveFormSubmitDecision {
    public static resolve(options: ReactiveFormSubmitDecisionOptions): ReactiveFormSubmitDecisionResult {
        if (!options.hasForm || !options.hasModel) {
            return ReactiveFormSubmitDecision.create('skip');
        }

        if (options.formType !== FormType.DELETION && options.hasInvalidSubmittableControls) {
            return ReactiveFormSubmitDecision.create('showValidationErrors');
        }

        if (options.formType === FormType.DELETION && options.recordHasAssociatedData && !options.hasWarning) {
            return ReactiveFormSubmitDecision.create('showDeletionWarning');
        }

        if (options.requiresExistingRecordId && !options.hasExistingRecordId) {
            return ReactiveFormSubmitDecision.create('missingRecordId');
        }

        return ReactiveFormSubmitDecision.create('submit');
    }

    private static create(action: ReactiveFormSubmitDecisionAction): ReactiveFormSubmitDecisionResult {
        return {
            action,
            canSubmit: action === 'submit',
        };
    }
}
